import Configuration from '@/agilis/util/Configuration'
import DeliveryGroupV2 from '../DeliveryGroupV2/DeliveryGroupV2'
import Vue from 'vue'

export default {
  name: 'DeliveryGroup',
  mixins: [
    DeliveryGroupV2
  ],

  computed: {
    configuration () {
      return Configuration.getTrackerType(this.applicationId, this.trackerTypeId).trackerTypes.deliveryGroup.dataTable
    },
    title () {
      return this.$t('sales.label.wpGroups')
    }
  },
  methods: {
    async fetchData () {
      this.startLoader({ id: 'fetch-data' })
      const body = {}
      body.filterTerms = [
        {
          field: 'deliveryId',
          operator: 'EQUALS',
          value: this.trackerId
        }
      ]
      try {
        // Load group
        const dataTableWithGroups = this.$refs.dataTableWithGroups
        if (dataTableWithGroups) {
          const url = dataTableWithGroups.searchApi
          const response = await this.$axios.post(url, body, this.$axios.agilisRequestConfig(url))
          const data = response.data.items
          // Load the priceItems details via query
          const priceItems = await this.fetchPriceItems(data)

          // Update the table immediately with the base data (without clannResidue)
          this.items = data.map((wp) => this.decorateWpData(wp, priceItems, {}))
          dataTableWithGroups.items = this.items ?? []
          this.$emit('wp-group-items-update', data)

          // Now fetch the clannResidue data in parallel
          this.fetchClannResidue(data).then(clannResidue => {
            // Once clannResidue is ready, update the items again
            this.items = data.map((wp) => this.decorateWpData(wp, priceItems, clannResidue))
            dataTableWithGroups.items = this.items ?? []
          }).catch(error => {
            this.notifyError(error)
          })
        }
      } catch (error) {
        this.notifyError(error)
      }
      this.dataLoaded = true
      this.stopLoader({ id: 'fetch-data' })
    },

    async editWPGroup (group) {
      this.startLoader({ id: 'edit-group' })
      let deliveryGroupId = group.id
      const url = this.$axios.agilisUrlDeliveryGroupWpMove(
        this.applicationId,
        this.trackerTypeId,
        this.trackerId,
        deliveryGroupId,
        this.wp.workpackageId)

      Vue.axios.put(url, {}, Vue.axios.agilisRequestConfig(url))
        .then(() => {
          this.fetchData()
          this.closeDialog()
        })
        .catch((error) => {
          this.notifyError(error)
        })
      this.stopLoader({ id: 'edit-group' })
    }
  }
}
